<!-- SearchSection.vue -->
<template>
  <div class="result-wrap tab-content">
    <div class="title-wrap" :class="{ collapsed: !opened }" @click="toggle">
      <h2 class="section-title">{{ title }}  <span v-if="!opened">({{ sectionTotal }}건)</span></h2>
    </div>
    <div v-show="opened">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps({
  title: String,
  sectionTotal: { type: Number, default: 0 },
})
const opened = ref(true)
const toggle = () => (opened.value = !opened.value)
</script>

<style scoped>
.title-wrap {
  cursor: pointer;
  user-select: none;
}

.title-wrap .section-title {
  color: white; /* 기본 색상 */
  transition: color 0.3s ease;
}

.title-wrap.collapsed .section-title {
  color: gray; /* 접힌 상태 색상 (예: 연한 회색) */
}

</style>